import Header from "@/components/navigation/Header";
import { ImportWizard } from "./ImportWizard";

/**
 * Page d'import : pleine largeur, miroir de `/export`.
 *
 * Volontairement une **page** et non un dialogue : l'arbitrage des liaisons du
 * lot suivant est une grille avec des centaines de lignes et des actions
 * groupees, ce qui ne rentre pas dans un dialogue. Et la symetrie Export ↔
 * Import vaut beaucoup pour la decouvrabilite.
 *
 * Pas de `DashboardParamsProviders` : l'import n'a ni filtres, ni recherche
 * avancee, ni pagination — inutile de reprendre cette partie de `export.tsx`.
 */
export const Import = () => (
  <>
    <Header />
    <div className="flex flex-col items-center w-full bg-white">
      <div className="w-[90%] py-6">
        <ImportWizard />
      </div>
    </div>
  </>
);

export default Import;
